import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

type Props = {
  visible: boolean;
  onHide: () => void;
};

/**
 * One-time greeting shown before the cover design picker for a brand new
 * template, introducing the Report Designer and its beta status.
 */
export const WelcomeModal = ({ visible, onHide }: Props) => {
  return (
    <Dialog
      header={<span className="text-[var(--ion-color-primary)]">Welcome to the Report Designer</span>}
      visible={visible}
      onHide={onHide}
      style={{ width: "min(520px, 94vw)" }}
      dismissableMask
    >
      <p className="mt-0 text-slate-600">
        This is where you design and customise the report templates used to generate your PDF reports: covers,
        sections, headers/footers and more, all in one place.
      </p>
      <p className="text-slate-600">
        It's currently in <span className="font-semibold">beta</span> and we've been working hard on it. We'd
        love to hear how it feels to use, so please{" "}
        <a
          href="https://www.defectwise.com.au/support"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[var(--ion-color-primary)] underline"
        >
          get in touch
        </a>{" "}
        with any feedback on usability or anything else you notice.
      </p>
      <div className="mt-6 flex justify-end">
        <Button
          label="Get started"
          onClick={onHide}
          className="border-none"
          style={{ background: "var(--ion-color-primary)", color: "#ffffff" }}
        />
      </div>
    </Dialog>
  );
};
